export var BubbleVariantType;
(function (BubbleVariantType) {
    BubbleVariantType["INBOUND_MESSAGE"] = "INBOUND_MESSAGE";
    BubbleVariantType["INBOUND_MESSAGE_WITH_BUTTON"] = "INBOUND_MESSAGE_WITH_BUTTON";
    BubbleVariantType["INBOUND_MESSAGE_CHATBOT"] = "INBOUND_MESSAGE_CHATBOT";
    BubbleVariantType["INBOUND_MESSAGE_CHATBOT_WITH_BUTTON"] = "INBOUND_MESSAGE_CHATBOT_WITH_BUTTON";
    BubbleVariantType["OUTBOUND_MESSAGE"] = "OUTBOUND_MESSAGE";
})(BubbleVariantType || (BubbleVariantType = {}));
//# sourceMappingURL=variants.js.map